import { UPDATE_WEBHOOK_MUTATION, WEBHOOKS_QUERY } from '../operations/index.js';
import { useSandboxCredentials } from './useSandboxCredentials.js';
import { useMutation } from '@apollo/react-hooks';
import { setDatadogError } from '../utils';

const noop = () => {};

const useUpdateWebhook = (onCompleted = () => {}) => {
  let customError = null;

  /* eslint-disable */
  const {
    data: { accessToken, applicationToken, shortCode },
    error: sandboxError,
    loading: sandboxLoading,
  } = useSandboxCredentials();
  /* eslint-enable */

  const sandboxCredentialsVariables = {
    accessToken,
    applicationToken,
    'x-marqeta-program-short-code': shortCode,
  };

  const refetchQueries = [
    {
      query: WEBHOOKS_QUERY,
      variables: sandboxCredentialsVariables,
    },
  ];

  const [mutate, { loading, error, called }] = useMutation(UPDATE_WEBHOOK_MUTATION, {
    onCompleted: (data) => onCompleted(data, error),
    refetchQueries,
    awaitRefetchQueries: true,
    notifyOnNetworkStatusChange: true,
  });

  const updateWebhook = async (variables) => {
    try {
      const { data } = await mutate({
        variables: {
          ...variables,
          ...sandboxCredentialsVariables,
        },
      });
      if (data.errors?.length > 0) {
        customError = data.errors;
        setDatadogError(customError, { source: 'update-webhook' });
        onCompleted(data, customError);
      } else {
        return data;
      }
    } catch (_e) {
      customError = _e;
      setDatadogError(customError, { source: 'update-webhook' });
      onCompleted({}, customError);
    }
  };

  return {
    called,
    updateWebhook: updateWebhook || noop,
    error: sandboxError || error || customError,
    loading: sandboxLoading || loading,
  };
};

export { useUpdateWebhook };
